var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackbuttonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57741 13.4223C6.90285 13.7477 7.43048 13.7477 7.75592 13.4223C8.08136 13.0968 8.08136 12.5692 7.75592 12.2438L3.34518 7.83301H14.6667C15.1269 7.83301 15.5 7.45991 15.5 6.99967C15.5 6.53944 15.1269 6.16634 14.6667 6.16634H3.34518L7.75592 1.7556C8.08136 1.43016 8.08136 0.902523 7.75592 0.577086C7.43049 0.251648 6.90285 0.251648 6.57741 0.577086L0.744078 6.41042C0.418641 6.73586 0.418641 7.26349 0.744078 7.58893L6.57741 13.4223Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackbuttonIcon);
export default __webpack_public_path__ + "static/media/backbutton-icon.946fac6e8b90f7bcdc33fd182ade6bab.svg";
export { ForwardRef as ReactComponent };